<template>
  <li
    :class="[
      'depth-' + level,        
      { open: node.open }
    ]"
  >
    <a
      href="#"
      :class="{
        parent: hasChildren,
        on: node.active
      }"
      @click.prevent="onClick"
    >
      {{ node.menuNm }}
      <span v-if="hasChildren" class="unfd">
        {{ node.open ? ' 접기' : ' 펼치기' }}
      </span>
    </a>

    <transition name="fade">
      <ul v-show="node.open && hasChildren">
        <SideNode
          v-for="child in node.children"
          :key="child.menuId"
          :node="child"
          @click-node="$emit('click-node', $event)"
        />
      </ul>
    </transition>
  </li>
</template>

<script setup>
import { computed } from 'vue'
import SideNode from './SideNode.vue'

const props = defineProps({
  node: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['click-node'])

const hasChildren = computed(
  () => props.node.children && props.node.children.length > 0
)

// node 기준 level 계산
const level = computed(
  () => props.node.menuLevel || props.node.level || 1
)

const onClick = () => {
  emit('click-node', props.node)
}
</script>
